import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { assetSvgPath } from 'interfaces/constants'

export const StyledDueDate = styled.div`
  position: relative;
  width: 100%;
  min-height: calc(100vh - 56px);

  &[data-status='loading'] {
    display: none;
  }

  .due-date-calculator-bottom-divider {
    border-width: 4px;
    border-color: #f7f9fc;
  }

  .recalculate-btn {
    display: flex;
    margin: 24px 0;

    img {
      margin-right: 8px;
    }
  }

  ${MediaQueries.mbUp} {
    display: flex;
  }

  input[type='date'] {
    &:after {
      width: 16px;
      height: 16px;
      background-image: url('${assetSvgPath}/calendar.svg');
      background-repeat: no-repeat;
      background-size: contain;
      content: '';
    }
  }

  input[type='date']::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: -16px;
    width: auto;
    height: auto;
    background: transparent;
    color: transparent;
    cursor: pointer;
  }

  input[type='date']:active,
  input[type='date']:focus {
    ::-webkit-calendar-picker-indicator {
      outline: none;
    }
  }
`

export const StyledDueDateLeft = styled.div`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  background-color: ${theme.colors.pink100};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;

  & > div {
    z-index: 1;
  }

  ${MediaQueries.mbUp} {
    background-color: transparent;
    width: 43.25%;
    padding-top: 0.5rem;
    padding-inline: 1rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  ${MediaQueries.lgPcUp} {
    padding-inline: 7.5rem;
  }
`
export const StyledDueDateRight = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  flex: 1;
  min-width: 0;

  &[data-error='true'] {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${MediaQueries.mbUp} {
    background-color: ${theme.colors.pink50};
  }
`

export const StyledDueDateResult = styled.div`
  position: relative;

  ${MediaQueries.mbUp} {
    padding: 2.5rem 3rem;
  }
  ${MediaQueries.lgPcUp} {
    padding: 2.5rem 5rem;
  }
`
